// extracted by mini-css-extract-plugin
export var infoRow = "_ot-2";
export var labelContainer = "_ot-0";
export var rightInfo = "_ot-1";